import { useState, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import Modal from './Modal'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../redux/hooks'
import Select from './Select'
import useAuthUserActions from '../hooks/auth/useAuthUserActions'

interface Props {
    onCloseClick?: () => void
    visible: boolean
}

const CustomerSelectorModal = ({
    onCloseClick,
    visible
} : Props) => {
    const companyGroupPrefix = 'group_'
    const customerPrefix = 'customer_'
    const styles = useStyles()
    const { t } = useTranslation('common');
    const [selectedValue, setSelectedValue] = useState<string>()

    const authenticatedUser = useAppSelector(state => state.auth.authenticatedUser)
    const currentCustomerId = useAppSelector(state => state.auth.currentCustomerId)
    const currentCompanyGroupId = useAppSelector(state => state.auth.currentCompanyGroupId)

    const { switchToCustomer, switchToCompanyGroup } = useAuthUserActions()

    useEffect(() => {
        if (visible && currentCompanyGroupId) {
            setSelectedValue(`${companyGroupPrefix}${currentCompanyGroupId}`)
        } else if (visible && currentCustomerId) {
            setSelectedValue(`${customerPrefix}${currentCustomerId}`)
        } 
    }, [visible])

    const handleOnSelect = () => {
        if (selectedValue) {
            if (selectedValue.startsWith(customerPrefix)) {
                const selectedCustomerId = selectedValue.substring(customerPrefix.length)
                switchToCustomer(selectedCustomerId, currentCustomerId != null)
            } else if (selectedValue.startsWith(companyGroupPrefix)) {
                const selectedCompanyGroupId = selectedValue.substring(companyGroupPrefix.length)
                switchToCompanyGroup(selectedCompanyGroupId, currentCompanyGroupId != null)
            }
        }

        handleOnClose()
    }

    const handleOnClose = () => {
        onCloseClick && onCloseClick()
    }

    const getOptions = () => {
        if (!authenticatedUser)
            return []

        var companyGroups = authenticatedUser.companyGroups.map(x => {
            return { name: x.name, value: `${companyGroupPrefix}${x.id}` }
        })
        var customers = authenticatedUser.customers.map(x => {
            return { name: x.customerName, value: `${customerPrefix}${x.customerId}` }
        })

        return companyGroups.concat(customers)
    }

    return (
        <Modal
            title={t('selectCustomer')}
            visible={visible}
            okButtonTitle={t('select')}
            cancelButtonTitle={t('cancel')}
            onHide={() => handleOnClose()}
            onOkClick={() => handleOnSelect()}
            onCancelClick={() => handleOnClose()}
        >
            <div className={styles.row}>
                <Select
                    id='customer'
                    key='customer'
                    label={t('company')}
                    options={getOptions()}
                    selectedValue={selectedValue ?? undefined}
                    onSelect={(value) => setSelectedValue(value)}
                />
            </div>
        </Modal>
    )
}

export default CustomerSelectorModal

const useStyles = createUseStyles({
    row: {
        paddingBottom: 12
    }
})
